import { createPermission } from "@backstage/plugin-permission-common";
import {
  stanReadPermission,
  stanTasksPermission,
  stanAdminPermission,
  hrWritePermission,
} from "@internal/plugin-stan";

/**
 * Permission to access the API documentation
 */
export const apiDocsAccessPermission = createPermission({
  name: "api-docs.access",
  attributes: { action: "read" },
});

/**
 * Permission to access the technical documentation
 */
export const docsAccessPermission = createPermission({
  name: "docs.access",
  attributes: { action: "read" },
});

/**
 * Permission to access the scaffolder (create templates)
 */
export const createAccessPermission = createPermission({
  name: "create.access",
  attributes: { action: "read" },
});

/**
 * Permission to access the resume generator
 */
export const resumeGeneratorAccessPermission = createPermission({
  name: "resume-generator.access",
  attributes: { action: "read" },
});

// Re-export STAN permissions
export {
  stanReadPermission,
  stanTasksPermission,
  stanAdminPermission,
  hrWritePermission,
};
